import { map, insert } from 'ramda';
import applicationModel from './application';
import UserCountModel from './user-count';
import idmuserinfoModel from './idmuserinfo';

const convertTime = (period) => {
  const currentTime = Date.now();
  const periodToMilliseconds = period * 8.64e7;
  const cutOffTime = currentTime - periodToMilliseconds;
  return cutOffTime;
};

const getCountForPeriod = (domain, period) => {
  const Idmuserinfo = idmuserinfoModel();
  if (period) {
    const cutOff = convertTime(period);

    return Idmuserinfo.portalUsersCountInDomain(domain, cutOff);
  }
  return Idmuserinfo.portalUsersCountInDomain(domain);
};

const getCounts = async (domain, periods) => {
  const mapPeriods = async (period) => {
    const count = await getCountForPeriod(domain, period);
    return { period, count };
  };
  const totalCount = await getCountForPeriod(domain);

  return Promise.all(
    insert(0, { period: 0, count: totalCount }, map(mapPeriods, periods)),
  );
};

const updateCounts = async (periods) => {
  const UserCount = UserCountModel();
  const Application = applicationModel();
  try {
    const apps = await Application.findApplications('', 0, 9999);
    const eachDomain = x => x.fields.domain;
    const domains = map(eachDomain, apps.applications);
    const mapDomains = async (domain) => {
      const counts = await getCounts(domain, periods);
      const update = { timeUpdated: Date.now(), domain, counts };
      const success = await UserCount.newUserCount(update);
      return success;
    };
    Promise.all(map(mapDomains, domains));
  } catch (error) {
    return error;
  }
  return 'updated user counts in mongo';
};

export default updateCounts;
